import { ArrowRight } from '@dreamstack/icons/src/icon-components/ArrowRight'
import type { FunctionComponent } from 'react'

export const AuthButtonArrow: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  return (
    <ArrowRight className="text-accentroWhite-full ml-px-20 w-px-32 h-px-32" />
  )
}
